export default "__VITE_ASSET__DN5M5X$f__"